module.exports={author:"Eleni Sikelianos",date:"04/01/2021",publishDate:"11/23/2020",highlighted:!1,tags:"",title:"Animal Light"};